<template>
  <div class="articlePseudo ">
    <div class='article'>
      <div class="title">
        <p>原文</p>
        <el-button
          type='primary'
          size='mini'
          @click="viewDetails"
        >查看详情</el-button>
      </div>
      <div class="name">{{name}}</div>
      <div
        class="content"
        ref="articleDetail"
        v-html="content"
      >
      </div>
    </div>

    <div class="pseudoOriginal">
      <div class='article left'>
        <div class="title">
          <p>伪原创（中）</p>
        </div>
        <div class="name">{{name}}</div>
        <div
          class="content"
          ref="pseudoEng"
          v-html="pseudoZhContent"
        >
        </div>
      </div>

      <div class='article right'>
        <div class="title">
          <p>伪原创（英）</p>
        </div>
        <div class="name">{{name}}</div>
        <div
          class="content"
          ref="pseudoChina"
          v-html="pseudoContent"
        >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "articleDetail",
  props: {
    name: String,
    content: String,
    pseudoZhContent: String,
    pseudoContent: String
  },
  data() {
    return {
      height: ""
    };
  },
  mounted() {
    this.getDomheight();
  },
  methods: {
    // 查看详情
    viewDetails() {
      this.$emit("dialogShow");
    },
    // 计算元素高度
    getDomheight() {
      // 获取高度
      this.height = this.$refs.articleDetail.offsetHeight;
      // 设置高度
      this.$refs.pseudoChina.style.height = this.height + "px";
      this.$refs.pseudoEng.style.height = this.height + "px";
    }
  },
  // 监听内容，改变高度
  watch: {
    content() {
      setTimeout(() => {
        this.getDomheight();
      }, 10);
    }
  },
  components: {}
};
</script>

<style scoped lang='scss'>
.pseudoOriginal {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .article {
    flex: 1;
    margin-top: 10px;
  }
  .left {
    margin-right: 5px;
  }
  .right {
    margin-left: 5px;
  }
}
.article {
  height: 100%;
  background-color: #fff;
  padding: 20px;
  color: #333;
  .title {
    height: 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .name {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .content {
    width: 100%;
    height: 200px;
    font-size: 12px;
    line-height: 21px;
    overflow: auto;
    padding-right: 10px;
  }
  // 改变滚动条样式
  .content::-webkit-scrollbar {
    width: 4px;
  }
  .content::-webkit-scrollbar-thumb {
    background-color: #d8d8d8;
    border-radius: 2px;
  }
  .content::-webkit-scrollbar-track {
    background-color: #fff;
    border-radius: 2px;
  }
}
</style>
